import React, { useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import CaseTrackingDashboard from './CaseTracking/CaseTrackingDashboard';
import IncidentReport from './IncidentReport';
import PerformanceReports from './CaseTracking/PerformanceReports';
import MachineHistory from './MachineAnalytics/MachineHistory';
import TechnicianPerformanceDashboard from './MachineAnalytics/TechnicianPerformanceDashboard';
import FailureAnalysisReport from './MachineAnalytics/FailureAnalysisReport';
import RecurrentFailuresReport from './MachineAnalytics/RecurrentFailuresReport';
import PartsUsageReport from './MachineAnalytics/PartsUsageReport';
import PreventiveMaintenanceReport from './PreventiveMaintenance/PreventiveMaintenanceReport';
import usePreferredLanguage from '../../utilities/usePreferredLanguage';
import { translateUiText } from '../../utilities/siteTranslations';
import BonusesReport from './BonusesReport';
import { canViewBonuses, readReportUser } from './bonusReportHelpers';

const Reports = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const preferredLanguage = usePreferredLanguage();
    const t = (value) => translateUiText(value, preferredLanguage);

    return (
        <div className="p-4">
            <div className="mb-4">
                <h2>{t('Analytics & Reporting Hub')}</h2>
                <p className="text-color-secondary">{t('Comprehensive business insights and performance analytics')}</p>
            </div>

            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel header={t('Case Tracking Dashboard')}>
                    <CaseTrackingDashboard />
                </TabPanel>

                <TabPanel header={t('Incident Report')}>
                    <IncidentReport />
                </TabPanel>

                <TabPanel header={t('Performance Reports')}>
                    <PerformanceReports />
                </TabPanel>

                <TabPanel header={t('Machine History')}>
                    <MachineHistory />
                </TabPanel>

                <TabPanel header={t('Technician Performance')}>
                    <TechnicianPerformanceDashboard />
                </TabPanel>

                <TabPanel header={t('Failure Analysis')}>
                    <FailureAnalysisReport />
                </TabPanel>

                <TabPanel header={t('Recurrent Failures')}>
                    <RecurrentFailuresReport />
                </TabPanel>

                <TabPanel header={t('Parts Usage')}>
                    <PartsUsageReport />
                </TabPanel>

                <TabPanel header={t('Preventive Maintenance')}>
                    <PreventiveMaintenanceReport />
                </TabPanel>
                {canViewBonuses(readReportUser()) && <TabPanel header={t('Bonificaciones')}>
                    <BonusesReport />
                </TabPanel>}
            </TabView>
        </div>
    );
};

export default Reports;
